
import { EVENTS } from '../../shared/Events';

class SndManager {
  constructor() {
    // const
    this.AMBI_VOLUME = 1.0;
    this.I_VERSIONS = {
      andel: 2,
      apatyka: 3,
      babka: 4,
      certandel: 9,
      'certandel-mikulas': 1,
      dvere: 5,
      dyk: 5,
      'dyk-mikulas': 1,
      god: 5,
      holka: 3,
      'holka-mikulas': 1,
      holub: 1,
      hospoda: 3,
      host: 4,
      klucik: 3,
      kocka: 3,
      koular: 3,
      labuda: 3,
      mama: 3,
      opilci: 4,
      pani: 3,
      pes: 3,
      polivka: 5,
      ponocny: 12,
      preclik: 2,
      puncocha: 3,
      syn: 2,
      ukolebavka: 3,
      zametani: 4,
      'zametani-mikulas': 4,
    };
    this.FADE_SFX = [
      'ukolebavka',
      'hospoda',
    ];

    // main vars
    this.deSound = null;
    this.isMuted = false;

    // paths
    this.sndPath = '/cms/advent2017-sounds/snd/';
    this.quality = '-hi';

    // ambi
    this.ambiActive = false;
    this.ambiLoop = null;
    this.ambiType = -10;

    // items sfx
    this.itemsPool = {};
    this.itemSfx = null;
    this.itemTempId = 0;
    this.actualItemName = ''; // for stop
    this.itemTempName = '';

    // sfx
    this.actualSfx = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // settings
    if (aPage.features.isLocal) {
      this.sndPath = '../../advent2017-sounds/snd/';
    }
    /*
    if (aPage.features.isMobile) {
      this.quality = '-lo';
    }
    */
    // init manager
    if (aPage.iOsSndManagerRef) {
      this.deSound = aPage.iOsSndManagerRef;
    } else {
      this.deSound = new DeSnd.SoundManager();
    }

    // muter
    this.setAutoMute();

    // item pools
    this.initItemPools();

    // signals
    aScene.signals.sceneCallMain.add(this.callMainFc, this);
  }

  setAutoMute() {
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.deSound.mute = true;
      } else if (!this.isMuted) {
        this.deSound.mute = false;
      }
    }, false);
  }

  // --------------------------------------------------------------
  // Main Call
  // --------------------------------------------------------------

  callMainFc(sgType) {
    switch (sgType) {
      case EVENTS.MOVE_TO_HEAVEN_START:
      case EVENTS.MOVE_TO_TOWN_START:
        this.stopAmbi();
        setTimeout(() => {
          this.startAmbi(sgType === EVENTS.MOVE_TO_TOWN_START ? 0 : 1);
        }, 2500);
        break;
      default:
    }
  }

  // --------------------------------------------------------------
  // Disable Mute - called from colorbox
  // --------------------------------------------------------------

  disableMute(doMute) {
    this.isMuted = doMute;
    this.deSound.mute = doMute;
  }

  // --------------------------------------------------------------
  // Ambi Loop
  // --------------------------------------------------------------

  playAmbi(doPlay) {
    sndMuted = !doPlay;
    this.ambiActive = doPlay;
    if (this.ambiActive) {
      this.startAmbi(aScene.sceneManager.sceneDestination);
    } else {
      this.stopAmbi();
    }
  }

  startAmbi(type) {
    if (this.ambiActive) {
      if (this.ambiLoop && this.ambiType === type) {
        this.ambiLoop.play();
        this.ambiLoop.fade(this.ambiLoop.volume, this.AMBI_VOLUME, 500);
      } else if (type !== -1) {
        // init/swap - blocked during transition
        this.setAmbi(type);
      }
    }
  }

  stopAmbi() {
    if (this.ambiLoop) {
      this.ambiLoop.pause();
    }
  }

  setAmbi(type) {
    this.ambiType = type;
    if (this.ambiType === 0) {
      // town
      this.ambiLoop = this.getAmbi(`ambi-0-${Math.round(Math.random())}`);
    } else if (this.ambiType === 1) {
      // heaven
      this.ambiLoop = this.getAmbi('ambi-1-0');
    }
  }

  getAmbi(ambiName) {
    const ambi = this.deSound.addSound(ambiName, `${this.sndPath}ambient/${ambiName}${this.quality}`);
    ambi.loop = true;
    ambi.fadeDuration = 500;
    ambi.inFade = true;
    ambi.outFade = true;
    ambi.volume = this.AMBI_VOLUME;
    ambi.play();
    return ambi;
  }

  muteAmbi(doMute) {
    if (this.ambiActive && this.ambiLoop) {
      if (doMute) {
        this.ambiLoop.fade(this.AMBI_VOLUME, 0, 500);
      } else {
        this.ambiLoop.fade(0, this.AMBI_VOLUME, 300);
      }
    }
  }

  // --------------------------------------------------------------
  // Items
  // --------------------------------------------------------------

  initItemPools() {
    Object.keys(this.I_VERSIONS).forEach((key) => {
      this.itemsPool[key] = {
        last: -1,
        pool: [],
      };
      this.setItemPool(key);
    });
  }

  setItemPool(itemName) {
    for (let a = 0; a < this.I_VERSIONS[itemName]; a += 1) {
      if (a !== this.itemsPool[itemName].last || this.I_VERSIONS[itemName] === 1) {
        this.itemsPool[itemName].pool.push(a);
      }
    }
  }

  playItemSfx(itemName) {
    // try stop old
    this.stopItemSfx(this.actualItemName);
    this.actualItemName = itemName;

    // get id
    if (this.itemsPool[itemName].pool.length === 0) {
      this.setItemPool(itemName);
    }
    this.itemsPool[itemName].last = this.itemsPool[itemName].pool.splice(
      Math.round(Math.random() * (this.itemsPool[itemName].pool.length - 1)),
      1,
    )[0];
    this.itemTempId = this.itemsPool[itemName].last;

    // set name
    this.itemTempName = `i-${itemName}-${this.itemTempId}`;

    // play
    this.itemSfx = this.deSound.addSound(this.itemTempName, `${this.sndPath}sfx/items/${this.itemTempName}${this.quality}`);
    this.itemSfx.outFade = true;
    if (aPage.features.isTouch) {
      this.itemSfx.once('complete', this.itemSfxComplete, this);
    }
    this.itemSfx.play();

    // try ambi mute
    if (this.FADE_SFX.indexOf(itemName) !== -1) {
      this.muteAmbi(true);
    }
  }

  stopItemSfx(itemName) {
    if (this.itemSfx && this.actualItemName === itemName) {
      this.itemSfx.stop();
      this.itemSfx = null;

      // try ambi mute
      if (this.FADE_SFX.indexOf(itemName) !== -1) {
        this.muteAmbi(false);
      }
    }
  }

  itemSfxComplete() {
    aScene.itemsHelper.hitEnabled = false;
    aScene.itemsHelper.deSelectItem();
  }

  // --------------------------------------------------------------
  // Sfx
  // --------------------------------------------------------------

  playSfx(sfxName) {
    this.actualSfx = this.deSound.addSound(sfxName, `${this.sndPath}sfx/${sfxName}${this.quality}`).play();
  }
}

export default SndManager;



// WEBPACK FOOTER //
// ./src/js/scene/helpers/SndManager.js